import { Block, Logo } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';

import { shouldShowHeaderNavigationForV2 } from '../../layout/shouldShowHeaderNavigationForV2.tsx';
import { WebOnlyWrapper } from '../WebOnly/WebOnlyWrapper.tsx';

const Wrapper = (c: ReactNode) => (
  <Link to="/orders" id="home-link" data-testid="home-link">
    {c}
  </Link>
);

export const LogoHomeLink = () => {
  const { orderId } = useParams();

  const shouldShowHeaderNavigation =
    !!orderId && shouldShowHeaderNavigationForV2(location.pathname);

  return (
    <Block
      marginTop="4px"
      alignSelf={shouldShowHeaderNavigation ? 'flex-start' : undefined}
      paddingTop={shouldShowHeaderNavigation ? '6px' : undefined}
    >
      <WebOnlyWrapper wrapper={Wrapper}>
        <Logo height={32} width={32} />
      </WebOnlyWrapper>
    </Block>
  );
};
